class Tabs {
  // todo стоит добавить возможность отключения пагинации и отображения элементов пагинации
  constructor(wrapperSelector = ".tabs-wrapper") {
    this.wrappers = document.querySelectorAll(wrapperSelector);
    this.init();
  }

  init() {
    this.wrappers.forEach((wrapper) => {
      const controls = wrapper.querySelectorAll(".tabs-control");
      const contents = wrapper.querySelectorAll(".tabs-content");
      const isPaginated = wrapper.hasAttribute("data-tabs-pagination");

      controls.forEach((control) => {
        control.addEventListener("click", () => {
          const targetId = control.dataset.tabControlId;

          controls.forEach((c) => c.classList.remove("active"));
          contents.forEach((content) => content.classList.remove("active"));

          control.classList.add("active");
          const targetContents = wrapper.querySelectorAll(
            `.tabs-content[data-tab-id="${targetId}"]`
          );
          if (targetContents) {
            targetContents.forEach((content) => {
              content.classList.add("active");
              if (isPaginated) {
                this.setupPagination(content);
              }
            });
          }
        });
      });

      if (controls.length > 0) {
        controls[0].click();
      }
    });
  }

  setupPagination(contentEl) {
    const elements = Array.from(contentEl.querySelectorAll(".tabs-element"));
    const pageSize = 10;
    const totalPages = Math.ceil(elements.length / pageSize);
    let currentPage = 1;

    // Удаляем старую пагинацию, если была
    let oldPagination = contentEl.querySelector(".tabs-pagination");
    if (oldPagination) oldPagination.remove();

    const renderPage = (page) => {
      const start = (page - 1) * pageSize;
      const end = start + pageSize;

      elements.forEach((el, i) => {
        el.style.display = i >= start && i < end ? "block" : "none";
      });

      currentPage = page;
      updatePaginationUI();
    };

    const updatePaginationUI = () => {
      pagination.innerHTML = "";

      const prev = document.createElement("button");
      prev.textContent = "←";
      prev.disabled = currentPage === 1;
      prev.addEventListener("click", () => renderPage(currentPage - 1));
      pagination.appendChild(prev);

      for (let i = 1; i <= totalPages; i++) {
        const pageBtn = document.createElement("button");
        pageBtn.textContent = i;
        pageBtn.classList.toggle("active", i === currentPage);
        pageBtn.addEventListener("click", () => renderPage(i));
        pagination.appendChild(pageBtn);
      }

      const next = document.createElement("button");
      next.textContent = "→";
      next.disabled = currentPage === totalPages;
      next.addEventListener("click", () => renderPage(currentPage + 1));
      pagination.appendChild(next);
    };

    const pagination = document.createElement("div");
    pagination.classList.add("tabs-pagination");
    contentEl.appendChild(pagination);

    renderPage(1);
  }
}

export default Tabs;
